import * as jQuery from 'jquery';
import AWS from 'aws-sdk';
import { getUser } from './user';
import config from '../config';

export const addUserCredits = async newCredits => {
  const user = await getUser();
  if (user === null) return { status: 'user not found' };
  const body = {
    newCredits
  };
  body.identity_id = AWS.config.credentials.identityId;
  const payload = JSON.stringify(body);
  const url = `${config.APIRoot}/images/buy/credits`;
  return jQuery.ajax({
    url: url,
    method: 'POST',
    contenType: 'application/json',
    data: payload
  });
};

export const setNewUserCredits = async () => {
  const user = await getUser();
  if (user === null) {
    return false;
  }
  const identity_id = AWS.config.credentials.identityId;
  const body = {
    identity_id
  };
  const payload = JSON.stringify(body);
  const url = `${config.APIRoot}/images/set/credits`;
  return jQuery.ajax({
    url: url,
    method: 'POST',
    contenType: 'application/json',
    data: payload
  });
};



// WEBPACK FOOTER //
// ./src/utils/user/credits.js